__webpack_require__.p = "https://images-cdn-staging.curipod.com/pr-2859bfa4/_next/";